import React, { useState, useEffect } from "react";
import { createPost, updatePost } from "../api/community";
import "../css/Form.css";

export default function PostForm({ communityId, topicId, existingPost, onSuccess, setlang }) {
  const [content, setContent] = useState(existingPost?.content || "");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (existingPost) {
      setContent(existingPost.content);
    }
  }, [existingPost]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = { content, image };
      if (existingPost) {
        await updatePost(communityId, topicId, existingPost.id, data);
      } else {
        await createPost(communityId, topicId, data);
      }
      if (onSuccess) onSuccess();
      setContent("");
      setImage(null);
    } catch (err) {
      setError(setlang==="en"?"Failed to save post. Please try again":"مشکلی در ایجاد پست رخ داد، لطفا دوباره وارد شو");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="form-container" onSubmit={handleSubmit}>
      {setlang === "en"? (
        <>
          <h2>{existingPost ? "Edit Post" : "Create Post"}</h2>
          {error && <p className="form-error">{error}</p>}
        </>
        
      ):(
        <>
          <h2>{existingPost ? "ویرایش پست" : "پست جدید"}</h2>
          {error && <p className="form-error">مشکلی در ایجاد پست پیش آمد</p>}
        </>
      )}

      <textarea
        rows="4"
        value={content}
        placeholder={setlang === "en" ? "Post Content":"محتوای پست"}
        onChange={(e) => setContent(e.target.value)}
        required
      />

      {setlang === "en" ? 
      <label>Attach Images</label>
      :
      <label>بارگذاری عکس</label>
      }
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImage(e.target.files[0])}
      />
      {setlang === "en" ? (
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : existingPost ? "Update" : "Post"}
        </button>
      ):(
        <button type="submit" disabled={loading}>
          {loading ? "در حال بارگذاری ..." : existingPost ? "به‌روزرسانی" : "ارسال"}
        </button>
      )}
    </form>
  );
}
